import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mfp_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const tokenStore = {
  get: () => localStorage.getItem("mfp_admin_token"),
  set: (t) => localStorage.setItem("mfp_admin_token", t),
  clear: () => localStorage.removeItem("mfp_admin_token"),
};
